/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import { supportSentErrorNotificationTimeout } from 'src/shared/app/support/settings/supportSettings';
import Notification from 'src/shared/app/notification/component/Notification';
import messages from 'src/shared/app/notification/l10n/notificationL10n.json';

type Props = {
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const MarketFavoriteNotificationDumb = (props: Props): React.Node => {
  const { handleDismiss, intl } = props;

  return (
    <Notification
      timeout={supportSentErrorNotificationTimeout}
      handleDismiss={handleDismiss}
      withError
    >
      {intl.formatMessage(messages.supportSentErrorNotification)}
    </Notification>
  );
};

export default compose(injectIntl)(MarketFavoriteNotificationDumb);
